import { Routes } from '@angular/router';
import { fetchAccountAclGuard } from 'src/app/acl/acl.guards';
import { checkIfAccountExistsOrRedirectOtherwise, updateContextGuard } from 'src/app/pages/routing.guards';
import { Account } from 'src/app/shared/account/account.types';
import { IndexPageComponent } from '../accounts/index-page/index-page.component';
import {
  forNonWhiteLabelOrForNewlyInvited,
  forNonWhiteLabelOrRedirectToWizardOtherwise
} from '../white-label/guards/white-label.guard';
import { IndexPageGuard } from './index-page.guard';
import { forManagerInOrganization } from '../organization/organization.guard';

const Routing: Routes = [
  {
    path: 'accounts',
    loadChildren: () =>
      import('../accounts/accounts.module').then(m => m.AccountsModule),
    canActivate: [forNonWhiteLabelOrRedirectToWizardOtherwise],
  },
  {
    path: 'advertiser/:contextId',
    loadChildren: () =>
      import('../advertiser/advertiser.module').then(m => m.AdvertiserModule),
    canActivate: [
      checkIfAccountExistsOrRedirectOtherwise(Account.Type.ADVERTISER),
      updateContextGuard(Account.Type.ADVERTISER),
      fetchAccountAclGuard('contextId'),
    ],
  },
  {
    path: 'publisher/:contextId',
    loadChildren: () =>
      import('../publisher/publisher.module').then(m => m.PublisherModule),
    canActivate: [
      checkIfAccountExistsOrRedirectOtherwise(Account.Type.PUBLISHER),
      updateContextGuard(Account.Type.PUBLISHER),
      fetchAccountAclGuard('contextId'),
    ],
  },
  {
    path: 'account/wizard',
    loadChildren: () =>
      import('../accounts/wizards/wizards.module').then(m => m.WizardsModule),
    canActivate: [forNonWhiteLabelOrForNewlyInvited],
  },
  {
    path: 'help',
    loadChildren: () => import('../help/help.module').then(m => m.HelpModule),
  },
  {
    path: 'organization/:organizationId',
    loadChildren: () =>
      import('../organization/organization.module').then(m => m.OrganizationModule),
    canActivate: [forManagerInOrganization]
  },
  {
    path: '',
    component: IndexPageComponent,
    canActivate: [IndexPageGuard]
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];

export { Routing };
